<template>
  <BaseChoice
    title="関連付ける法人を選択してください"
    resourceType="corporation"
    :fields="fields"
    :items="corporation.corporations"
    :totalItems="totalCorporations"
    :isFetching="isFetching"
  />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseChoice from '@/views/choices/Base.vue';

export default {
  data() {
    return {
      isFetching: false,
    };
  },
  components: {
    BaseChoice,
  },
  mounted() {
    this.$logger.debug('Start fetching Corporation for Choices');
    this.clearCorporations();
    this.isFetching = true;
    this.fetchCorporations().then(() => {
      this.isFetching = false;
      this.$logger.debug('Done fetching Corporation for Choices');
    });
  },
  computed: {
    fields() {
      return [
        {
          key: 'uid',
          label: '法人ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '法人名',
          sortable: true,
          thAttr: { width: 300 },
        },
        {
          key: 'choiceResource',
          label: '選択',
          sortable: false,
          thAttr: { width: 60 },
        },
      ];
    },
    ...mapState(['corporation']),
    ...mapGetters('corporation', ['totalCorporations']),
  },
  methods: {
    ...mapActions('corporation', ['fetchCorporations', 'clearCorporations']),
  },
};
</script>
